<template>
  <div id="map-find">
    <!-- <transition name="modal"> -->
        <div class="modal-mask">

          <div class="modal-wrapper">
            <div class="modal-container"
            role="dialog"
            aria-labelledby="modalTitle"
            aria-describedby="modalDescription" ref="mapContainer">
            <mapbox
              access-token="pk.eyJ1IjoiaG9ydGVuc2VncmVlbiIsImEiOiJja3N1Nm9iNGEwNjUyMm9xY2RlMDlwYWsxIn0.AMGi9L_80RYWk4sB5JYU5w"
              :map-options="{
                style: 'mapbox://styles/mapbox/streets-v10',
                zoom: 15,
                center: defaultCenterComputed,
                dragRotate: !isPhone,
                touchZoomRotate: true,
                pitchWithRotate: false,
                dragPan: true,
                scrollZoom: true,
                doubleClickZoom: true
              }"
            />
          </div>
        </div>
        <div class="closing">
          <span class="close-button" @click="handleClose">
            <i class="fas fa-times"></i>
          </span>
          </div>
      </div>
    <!-- </transition> -->
    
    <Cardmap v-if="selectedLodging" class="floating-cardmap" :lodging="selectedLodging" @unselect="unselectCardMap"  :idMarker="selectedMarker" :position="cardPosition" />
  </div>
</template>

<script>
  import Mapbox from 'mapbox-gl-vue';
  import Cardmap from '../components/cards/Cardmap.vue';
  import mapboxgl from 'mapbox-gl';
  import 'mapbox-gl/dist/mapbox-gl.css';
  
  mapboxgl.accessToken = 'pk.eyJ1IjoiaG9ydGVuc2VncmVlbiIsImEiOiJja3N1Nm9iNGEwNjUyMm9xY2RlMDlwYWsxIn0.AMGi9L_80RYWk4sB5JYU5w';
  
  export default{
    name: 'map-find',
    props: {
      markers: {
        type: Array,
        default: () => []
      },
      lodgings: Array,
      selectedLodgingId: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        mapVisible: false,
        selectedMarker: null,
        selectedLodging: null,
        cardPosition: 'right',
        isPhone: window.innerWidth <= 768,
        defaultCenter: [2.3522, 48.8566], // Default to Paris
      }
    },
    watch: {
      selectedLodging(newVal) {
        if (newVal) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflowY = '';
        }
      }
    },
    mounted() {
      console.log('[Mapfind] markers received:', this.markers);
      console.log('[Mapfind] lodgings passed:', this.lodgings);
      this.$nextTick(() => {
        // wait one more microtask to ensure portal has moved
        setTimeout(() => {
          this.mapInstance = new mapboxgl.Map({
            container: this.$refs.mapContainer,
            style: 'mapbox://styles/mapbox/streets-v10',
            zoom: 15,
            center: this.defaultCenterComputed,
            dragPan: true,
            scrollZoom: true,
            doubleClickZoom: true,
            keyboard: true,
            touchZoomRotate: true,
          });
          this.displayMarkers(this.mapInstance);
        }, 100);
      });
      // Hide map-test when Mapfind is shown
      this.hideMapTest();
      document.querySelectorAll('.nav-phone').forEach(el => {
				el.style.display = 'none';
			});
			document.querySelectorAll('.top-bar').forEach(el => {
				el.style.display = 'none';
			});
    },
    components: { Mapbox, Cardmap },
    computed: {
      defaultCenterComputed() {
        const selected = this.markers.find(m => m[2] === this.selectedLodgingId);
        if (selected) {
          return [selected[0], selected[1]];
        }

        if (this.markers.length > 0) {
          return [this.markers[0][0], this.markers[0][1]];
        }

        return [2.3522, 48.8566]; // Fallback center: Paris
      }
    },
    beforeDestroy() {
      try {
        // Only remove our specific map instance, not all maps
        if (this.mapInstance && this.mapInstance._container) {
          // Check if this is actually our map instance by checking both container and data attribute
          const mapContainer = this.mapInstance._container;
          if (mapContainer &&
              (mapContainer.closest('#map-find') || mapContainer.getAttribute('data-map-type') === 'mapfind')) {
            this.mapInstance.remove();
          }
          this.mapInstance = null;
        }
        document.querySelectorAll('.nav-phone').forEach(el => {
          el.style.display = 'block';
        });
        document.querySelectorAll('.top-bar').forEach(el => {
          el.style.display = 'block';
        });
      } catch (e) {
        console.warn('[Mapfind] Error during destroy:', e);
      }
      
      // Clean up any body classes we added
      document.body.classList.remove('no-scroll');
      document.body.style.overflow = '';
      
      // Show map-test again when Mapfind is destroyed
      this.showMapTest();
    },
    methods: {
      displayMarkers(map) {
        console.log('[Mapfind] Initializing map with markers:', this.markers);
        this.mapInstance = map;
        
        // Add a unique identifier to distinguish this map from Maptest
        if (map._container) {
          map._container.setAttribute('data-map-type', 'mapfind');
        }
        
        map.scrollZoom.enable();
        map.dragPan.enable();
        map.touchZoomRotate.enable();
        map.doubleClickZoom.enable();
        map.keyboard.enable();
        console.log('[Mapfind] lodgings passed:', this.lodgings);
        const bounds = new mapboxgl.LngLatBounds();

        this.markers.forEach(([lng, lat, id, price]) => {
          if (typeof lng !== 'number' || typeof lat !== 'number') {
            console.warn('[Mapfind] Invalid marker skipped:', [lng, lat, id]);
            return;
          }

          const priceLabel = document.createElement('div');
          priceLabel.textContent = `${price}€`;
          priceLabel.classList.add('price-label', id === this.selectedLodgingId ? 'black-label' : 'green-label');
          priceLabel.dataset.id = id;

          priceLabel.style.pointerEvents = 'auto';
          priceLabel.style.touchAction = 'auto';
          priceLabel.style.userSelect = 'none';

          priceLabel.addEventListener('click', (e) => {
            e.stopPropagation();
            this.selectedMarker = id;

            // Determine position for the card based on marker's screen location
            const point = map.project([lng, lat]); // Get screen coordinates
            const mapWidth = map.getContainer().clientWidth;
            const mapHeight = map.getContainer().clientHeight;
            const buffer = 260; // card width + margin

            let position = 'right';
            if (point.x > mapWidth - buffer) {
              position = 'left';
            } else if (point.x < buffer) {
              position = 'right';
            } else if (point.y < 180) {
              position = 'bottom';
            }

            this.cardPosition = position;

            if (Array.isArray(this.lodgings)) {
              document.body.classList.add('no-scroll');
              this.selectedLodging = this.lodgings.find(l => l.id === id);
              if (!this.selectedLodging) {
                document.body.classList.add('no-scroll');
                console.warn(`[Mapfind] Lodging not found for ID: ${id}`);
              } else {
                console.log('[Mapfind] Selected lodging:', this.selectedLodging);
              }
            } else {
              console.warn('[Mapfind] lodgings is not an array or is undefined');
              this.selectedLodging = null;
            }

            map.flyTo({ center: [lng, lat], zoom: 15 });
          });

          new mapboxgl.Marker(priceLabel).setLngLat([lng, lat]).addTo(map);

          bounds.extend([lng, lat]);
        });

        if (this.selectedLodgingId) {
          const selected = this.markers.find(m => m[2] === this.selectedLodgingId);
          if (selected) {
            map.flyTo({ center: [selected[0], selected[1]], zoom: 15 });
          } else {
            map.fitBounds(bounds, { padding: 50 });
          }
        } else {
          map.fitBounds(bounds, { padding: 50 });
        }
      },
      handleClose() {
        this.mapVisible = false;
        
        // Clean up our specific map instance before closing
        if (this.mapInstance && this.mapInstance._container) {
          const mapContainer = this.mapInstance._container;
          if (mapContainer &&
              (mapContainer.closest('#map-find') || mapContainer.getAttribute('data-map-type') === 'mapfind')) {
            try {
              this.mapInstance.remove();
              this.mapInstance = null;
            } catch (e) {
              console.warn('[Mapfind] Error removing map on close:', e);
            }
          }
        }
        
        // Clean up body classes and styles
        document.body.classList.remove('no-scroll');
        document.body.style.overflow = '';
        
        // Show map-test again when Mapfind is closed
        this.showMapTest();
        
        this.$emit('close');
      },
      onModalShown() {
        this.mapVisible = true;
        this.$nextTick(() => {
          setTimeout(() => {
            const mapComponent = this.$refs.mapbox;
            if (mapComponent && mapComponent.map) {
              mapComponent.map.resize();
            }
          }, 300);
        });
      },
      unselectCardMap() {
        this.selectedMarker = null;
        this.selectedLodging = null;
        document.body.classList.remove('no-scroll'); 
        if (this.mapInstance && this.markers.length > 0) {
          const bounds = new mapboxgl.LngLatBounds();
          this.markers.forEach(([lng, lat]) => {
            bounds.extend([lng, lat]);
          });

          this.mapInstance.fitBounds(bounds, {
            padding: 50,
            duration: 800,
            maxZoom: 15
          });
        }
      },
      hideMapTest() {
        // Hide all map-test elements
        const mapTestElements = document.querySelectorAll('#map-test');
        mapTestElements.forEach(element => {
          element.style.display = 'none';
        });
        
        // Also hide the map-panel container in LodgingsV2
        const mapPanel = document.querySelector('.map-panel');
        if (mapPanel) {
          mapPanel.style.display = 'none';
        }
      },
      showMapTest() {
        // Show all map-test elements
        const mapTestElements = document.querySelectorAll('#map-test');
        mapTestElements.forEach(element => {
          element.style.display = 'block';
        });
        
        // Also show the map-panel container in LodgingsV2
        const mapPanel = document.querySelector('.map-panel');
        if (mapPanel) {
          mapPanel.style.display = 'block';
        }
      },
    },
  }
</script>
<style lang="scss" scope='app/assets/stylesheets/components/map'>
.price-label {
  pointer-events: auto;
  touch-action: auto;
  user-select: none;
  cursor: pointer;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
}
.marker {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  cursor: pointer;
}
.floating-cardmap {
  z-index: 9999 !important;
  // position: absolute;
  // top: 10%; 
  // left: 5%;
}
#map-find{
  #card-map.right{
    top: 14%;
    left: 5%;
    right: auto
  }
  
  .modal-container {
    touch-action: none;
    -webkit-user-select: none;
    user-select: none;
  }
}
.no-scroll {
  height: 100vh;
  overflow: hidden;
  position: fixed;
  width: 100%;
}

@media (max-width: 480px) {
  #map-find #card-map.right{
    top: 55%;
    left: 5%;
  }
}

.mapboxgl-canvas{
  pointer-events: auto !important;
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;
}

.mapboxgl-canvas-container {
  touch-action: none;
}

.green-marker {
  background-color: #3b6152;
}

.black-marker {
  background-color: #000;
}

</style>